import Fields from '@/views/backstage/structure/theme_management/common/ThemeManagementFields'

let fields_type = [].concat(
    Fields['digital_type'], 
    Fields['preview_picture'],
    Fields['original_image'],
    Fields['carrier_type'],
    Fields['carrier_location'],
    Fields['description'])

let add_page = {
    fields: [].concat(Fields['theme_title'])
}
    
let edit_page = {
}

export default (theme_page_type) => {
    switch (theme_page_type) {
    case 'add_page': return add_page;
    case 'edit_page': return edit_page;
    default: return []
    }
}